import { baseBackend } from "../base/baseUrl";

const URL_CANCELLATION_REASONS = "/api/v2/cancellation/reasons";
const URL_BOOKING_CANCELLATION = "/api/v2/cancellation/booking";

const jsonHeaders = {
  "Content-Type": "application/json",
};

export const getCancellationReasons = async () =>
  baseBackend.get(URL_CANCELLATION_REASONS, {
    headers: jsonHeaders,
  });

export const createBookingCancellation = async (cancellation) =>
  baseBackend.post(URL_BOOKING_CANCELLATION, JSON.stringify(cancellation), {
    headers: jsonHeaders,
  });
